import { render, staticRenderFns } from "./PortfolioItem.vue?vue&type=template&id=2ff64534&scoped=true"
import script from "./PortfolioItem.vue?vue&type=script&lang=ts"
export * from "./PortfolioItem.vue?vue&type=script&lang=ts"
import style0 from "./PortfolioItem.vue?vue&type=style&index=0&id=2ff64534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff64534",
  null
  
)

export default component.exports